import { get } from "react-hook-form";
import { useShelvesContext } from "../context/ShelvesContext";
import { Shelf } from "../models/Shelf";
import { getShelves } from "../repositories/ShelvesRepository";
import { TransformDelayModelData } from "./TransformDelayModelData";
import { de } from "date-fns/locale";
type Props = {
  setIsLoading: (isLoading: boolean) => void;
  setError: (err: string) => void;
};

export const useSearchShelves = ({ setIsLoading, setError }: Props) => {
  const {
    actions: { setShelves, setShelvesNodes },
  } = useShelvesContext();

  return async () => {
    setIsLoading(true);

    const res = await getShelves();
    if (res.ok) {
      let mydataSource: any[] = [];
      const rows: Shelf[] = get(res, "data.tables[0].rows", []);

      rows.forEach((row: Shelf) => {
        const code = TransformDelayModelData(row);
        mydataSource = [...mydataSource, code];
      });

      setShelves(rows);
      setShelvesNodes(mydataSource);
      setIsLoading(false);
    } else {
      setError(res.message);
      setIsLoading(false);
    }
  };
};
